var _rect, _rect2, _rect3, _rect4, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongressImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-47"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,118.65a3.71,3.71,0,0,1,3.71-3.71,3.47,3.47,0,0,1,1.07.16,7.33,7.33,0,0,1-.09-1.15,7.87,7.87,0,0,1,7.87-7.86,7.75,7.75,0,0,1,1.45.14,6.87,6.87,0,0,1,12.74,3.47h.12a6.34,6.34,0,0,1,0,12.68H386.62A3.71,3.71,0,0,1,383,118.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,228.75a1.85,1.85,0,0,1,1.85-1.85,1.9,1.9,0,0,1,.54.07,3.45,3.45,0,0,1-.05-.57,3.94,3.94,0,0,1,3.94-3.93,4.28,4.28,0,0,1,.72.07,3.44,3.44,0,0,1,6.37,1.74h.06a3.17,3.17,0,1,1,0,6.34H195.06A1.86,1.86,0,0,1,193.26,228.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58,110.64a1.86,1.86,0,0,1,1.86-1.86,1.89,1.89,0,0,1,.53.08,3.48,3.48,0,0,1,0-.57,3.93,3.93,0,0,1,3.93-3.93,3.54,3.54,0,0,1,.73.07A3.44,3.44,0,0,1,90,106.16H90a3.17,3.17,0,0,1,0,6.34H78.38A1.84,1.84,0,0,1,76.58,110.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.38,220a1.85,1.85,0,0,1,1.86-1.85,1.88,1.88,0,0,1,.53.07,3.48,3.48,0,0,1,0-.57,3.93,3.93,0,0,1,3.93-3.93,4.4,4.4,0,0,1,.73.07,3.44,3.44,0,0,1,6.37,1.74h.06a3.17,3.17,0,0,1,0,6.34H60.19A1.87,1.87,0,0,1,58.38,220Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94,108.08a2.44,2.44,0,0,1,2.44-2.44,2.26,2.26,0,0,1,.69.11,6.3,6.3,0,0,1,0-.75,5.16,5.16,0,0,1,5.16-5.16,5,5,0,0,1,.95.09,4.5,4.5,0,0,1,8.35,2.28h.08a4.16,4.16,0,0,1,0,8.31H252.31A2.43,2.43,0,0,1,249.94,108.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,231.75a5.87,5.87,0,0,1-.17-1.12c-.14-2.31-2.34-1.94-4.22-2.26-1.47-.24,2.42-4-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.06s-1-1.29-.86-2c.27-1.12,1.83-1.16,3-.94a8,8,0,0,0,.61-2.29c.21-.76.81-1.57,1.6-1.47s1.19.93,1.92,1.1,1.57-.55,2.24-1.11,1.82-.91,2.27-.17c.27.44.11,1.06.39,1.49.5.75,1.66.29,2.39-.25s1.87-1,2.38-.27a2.83,2.83,0,0,1,.28.77c.34,1,1.41,1.48,2.24,2.11s1.5,1.9.79,2.67c-.35.38-1,.54-1.13,1s.41,1.15.9,1.57c.81.7,1,2.78-.12,3.35-.45.24-1.12.31-1.23.81s.36.8.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.22-.67.5a1,1,0,0,0,.06.6,3.25,3.25,0,0,1,.1,1.16.51.51,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.32-.48-3.27.87a1.2,1.2,0,0,1-.32.35,1.3,1.3,0,0,1-.43.11c-1.08.08-1.78-.58-2.76-.71-1.36-.17-1.65.53-2.85,1.09C71.26,233.58,70.34,233,70,231.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,229.81a5.27,5.27,0,0,1-.17-1.12c-.14-2.31-2.35-1.95-4.23-2.26-1.46-.25,2.42-4-.54-5.15a2.57,2.57,0,0,1-1.42-1,1.67,1.67,0,0,1,.64-2,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.26-1.11,1.82-1.15,2.95-.94a7.83,7.83,0,0,0,.61-2.28c.2-.76.81-1.57,1.6-1.47s1.19.92,1.92,1.1,1.57-.55,2.23-1.11,1.82-.91,2.28-.17c.27.44.11,1,.39,1.49.49.75,1.66.28,2.38-.25s1.88-1,2.39-.28a3.45,3.45,0,0,1,.28.78c.34,1,1.41,1.48,2.24,2.11s1.49,1.89.79,2.67c-.35.38-1,.53-1.13,1s.4,1.15.89,1.57c.82.69,1,2.77-.11,3.34-.46.24-1.12.32-1.23.82s.35.79.65,1.14a2.15,2.15,0,0,1-.65,3.2c-.26.12-.58.22-.68.49a1.07,1.07,0,0,0,.06.61,3.23,3.23,0,0,1,.11,1.16.52.52,0,0,1-.14.36.58.58,0,0,1-.35.1c-1.56.07-2.31-.49-3.26.87a1.1,1.1,0,0,1-.33.35,1,1,0,0,1-.43.1c-1.07.09-1.77-.58-2.75-.7-1.36-.18-1.65.53-2.85,1.09C89.23,231.64,88.32,231.09,88,229.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,218.36a5.27,5.27,0,0,1-.17-1.12c-.14-2.31-2.35-1.94-4.22-2.26-1.47-.24,2.41-3.95-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2.05,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.11,1.83-1.15,3-.93a8,8,0,0,0,.61-2.29c.2-.76.81-1.57,1.6-1.47s1.19.93,1.92,1.1,1.57-.55,2.24-1.11,1.82-.91,2.27-.17c.27.44.11,1.05.39,1.49.5.75,1.66.28,2.39-.25s1.87-1,2.38-.28a3,3,0,0,1,.28.78c.34,1,1.41,1.48,2.24,2.11s1.49,1.9.79,2.67c-.35.38-1,.53-1.13,1s.4,1.15.9,1.57c.81.7,1,2.78-.12,3.35-.45.23-1.12.31-1.23.81s.35.79.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.22-.68.5a1.05,1.05,0,0,0,.07.6,3.23,3.23,0,0,1,.1,1.16.52.52,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.32-.49-3.27.87a1.2,1.2,0,0,1-.32.35,1.29,1.29,0,0,1-.44.11c-1.07.08-1.77-.59-2.75-.71-1.36-.17-1.65.53-2.85,1.09C91,220.19,90.05,219.64,89.7,218.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54,224.06a5.87,5.87,0,0,1-.17-1.12c-.14-2.31-2.34-1.94-4.22-2.26-1.47-.24,2.42-4-.54-5.14a2.66,2.66,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2,4,4,0,0,1,2.25-.56c.48-.59.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.12,1.83-1.16,3-.94a8,8,0,0,0,.61-2.28c.21-.77.82-1.57,1.6-1.48s1.2.93,1.92,1.1,1.58-.55,2.24-1.11,1.82-.91,2.27-.17c.28.44.11,1.06.4,1.49.49.75,1.65.29,2.38-.25s1.87-1,2.38-.27a2.83,2.83,0,0,1,.28.77c.35,1,1.41,1.48,2.25,2.11s1.49,1.9.78,2.67c-.34.38-1,.54-1.13,1s.41,1.15.9,1.57c.82.7,1,2.78-.12,3.35-.45.24-1.12.31-1.23.81s.36.8.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.23-.67.5a1,1,0,0,0,.06.6,3.25,3.25,0,0,1,.1,1.16.51.51,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.31-.48-3.27.88a1.16,1.16,0,0,1-.32.34.92.92,0,0,1-.43.11c-1.08.09-1.78-.58-2.76-.71-1.36-.17-1.65.53-2.85,1.09C102.81,225.89,101.89,225.34,101.54,224.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,221.43a5.27,5.27,0,0,1-.17-1.12c-.14-2.31-2.34-1.95-4.22-2.26-1.47-.25,2.41-4-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.11,1.83-1.15,3-.94a7.83,7.83,0,0,0,.61-2.28c.2-.76.81-1.57,1.6-1.47s1.19.92,1.92,1.1,1.57-.55,2.24-1.11,1.82-.91,2.27-.17c.27.44.11,1,.39,1.49.5.75,1.66.28,2.39-.25s1.87-1,2.38-.28a3,3,0,0,1,.28.78c.34,1,1.41,1.48,2.24,2.11s1.49,1.89.79,2.67c-.35.38-1,.53-1.13,1s.41,1.15.9,1.57c.81.69,1,2.78-.12,3.34-.45.24-1.12.32-1.23.82s.36.79.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.22-.68.49a1.08,1.08,0,0,0,.07.61,3.23,3.23,0,0,1,.1,1.16.52.52,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.32-.49-3.27.87a1.2,1.2,0,0,1-.32.35,1.09,1.09,0,0,1-.44.1c-1.07.09-1.77-.58-2.75-.7-1.36-.18-1.65.53-2.85,1.09C114.78,223.26,113.86,222.71,113.51,221.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66,234.23a4.53,4.53,0,0,1-.13-.88c-.11-1.82-1.84-1.53-3.32-1.78-1.16-.19,1.9-3.11-.43-4a2.08,2.08,0,0,1-1.12-.79,1.31,1.31,0,0,1,.5-1.61,3.21,3.21,0,0,1,1.77-.45c.38-.46.07-1.15-.29-1.63s-.82-1-.68-1.59c.21-.87,1.44-.91,2.32-.73a6.47,6.47,0,0,0,.48-1.8c.16-.61.64-1.24,1.26-1.16s.94.73,1.51.86,1.24-.43,1.76-.87,1.44-.72,1.79-.14c.22.35.09.84.31,1.18.39.59,1.31.22,1.88-.2s1.48-.8,1.88-.21a2.39,2.39,0,0,1,.22.6c.27.78,1.11,1.17,1.76,1.67s1.18,1.49.62,2.1c-.27.3-.75.42-.89.8s.32.91.71,1.24c.64.55.76,2.19-.09,2.63-.36.19-.88.25-1,.64s.28.63.52.9a1.7,1.7,0,0,1-.52,2.52c-.21.1-.46.18-.53.39a.74.74,0,0,0,0,.48,2.52,2.52,0,0,1,.08.91.32.32,0,0,1-.38.36c-1.23.06-1.83-.38-2.58.69a.81.81,0,0,1-.25.27.78.78,0,0,1-.34.09c-.85.07-1.4-.46-2.17-.56-1.07-.13-1.3.42-2.24.86C114.66,235.67,113.94,235.24,113.66,234.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,229.81a6,6,0,0,1-.17-1.12c-.13-2.31-2.34-1.95-4.22-2.26-1.47-.25,2.42-4-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.11,1.83-1.15,3-.94a8.52,8.52,0,0,0,.61-2.28c.2-.76.81-1.57,1.59-1.47s1.2.92,1.92,1.1,1.58-.55,2.24-1.11,1.82-.91,2.27-.17c.28.44.11,1,.4,1.49.49.75,1.65.28,2.38-.25s1.87-1,2.38-.28a3,3,0,0,1,.28.78c.35,1,1.41,1.48,2.25,2.11s1.49,1.89.78,2.67c-.34.38-1,.53-1.13,1s.41,1.15.9,1.57c.82.69,1,2.77-.12,3.34-.45.24-1.12.32-1.23.82s.36.79.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.22-.67.49a1,1,0,0,0,.06.61,3.23,3.23,0,0,1,.1,1.16.52.52,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.31-.49-3.27.87a1.07,1.07,0,0,1-.32.35,1,1,0,0,1-.43.1c-1.08.09-1.78-.58-2.76-.7-1.36-.18-1.65.53-2.85,1.09C121.64,231.64,120.73,231.09,120.37,229.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54,210a6,6,0,0,1-.17-1.12c-.14-2.31-2.34-1.94-4.22-2.26-1.47-.24,2.42-3.95-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.68,1.68,0,0,1,.64-2.05,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.12,1.83-1.16,3-.94a8,8,0,0,0,.61-2.29c.21-.76.82-1.57,1.6-1.47s1.2.93,1.92,1.1,1.58-.55,2.24-1.11,1.82-.91,2.27-.17c.28.44.11,1.05.4,1.49.49.75,1.65.29,2.38-.25s1.87-1,2.38-.28a3,3,0,0,1,.28.78c.35,1,1.41,1.48,2.25,2.11s1.49,1.9.78,2.67c-.34.38-1,.53-1.13,1s.41,1.15.9,1.57c.82.7,1,2.78-.12,3.35-.45.23-1.12.31-1.23.81s.36.79.66,1.14a2.15,2.15,0,0,1-.66,3.2c-.26.12-.58.22-.67.5a1,1,0,0,0,.06.6,3.23,3.23,0,0,1,.1,1.16.52.52,0,0,1-.14.36.57.57,0,0,1-.34.1c-1.56.07-2.31-.49-3.27.87a1.2,1.2,0,0,1-.32.35,1.24,1.24,0,0,1-.43.11c-1.08.08-1.78-.59-2.76-.71-1.36-.17-1.65.53-2.85,1.09C102.81,211.81,101.89,211.26,101.54,210Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.17,210.76a5.08,5.08,0,0,1-.17-1.11c-.14-2.31-2.35-2-4.23-2.26-1.46-.25,2.42-3.95-.54-5.15a2.59,2.59,0,0,1-1.43-1,1.69,1.69,0,0,1,.65-2.05,4,4,0,0,1,2.25-.56c.48-.59.09-1.47-.38-2.07s-1-1.28-.86-2c.26-1.11,1.82-1.15,3-.94a7.83,7.83,0,0,0,.61-2.28c.2-.77.81-1.57,1.6-1.47s1.19.92,1.92,1.09,1.57-.54,2.23-1.1,1.82-.91,2.28-.18c.27.45.11,1.06.39,1.5.49.75,1.66.28,2.38-.25s1.88-1,2.39-.28a3.37,3.37,0,0,1,.28.77c.34,1,1.41,1.48,2.24,2.12s1.49,1.89.79,2.67c-.35.38-1,.53-1.13,1s.4,1.15.89,1.57c.82.69,1,2.77-.11,3.34-.46.24-1.12.31-1.23.81s.35.8.65,1.15a2.14,2.14,0,0,1-.65,3.19c-.26.13-.58.23-.68.5a1.07,1.07,0,0,0,.06.61,3.2,3.2,0,0,1,.11,1.15.58.58,0,0,1-.14.37.54.54,0,0,1-.35.09c-1.56.07-2.31-.48-3.26.88a1.07,1.07,0,0,1-.33.34.92.92,0,0,1-.43.11c-1.07.09-1.77-.58-2.75-.7-1.36-.18-1.65.52-2.85,1.09C87.43,212.59,86.52,212.05,86.17,210.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.83,217.06a5.27,5.27,0,0,1-.17-1.12c-.14-2.31-2.35-1.95-4.23-2.26-1.46-.25,2.42-4-.54-5.15a2.57,2.57,0,0,1-1.42-1,1.67,1.67,0,0,1,.64-2,4,4,0,0,1,2.25-.57c.48-.58.09-1.47-.38-2.07s-1-1.28-.86-2c.27-1.11,1.82-1.15,2.95-.94a7.83,7.83,0,0,0,.61-2.28c.2-.76.81-1.57,1.6-1.47s1.19.92,1.92,1.1,1.57-.55,2.23-1.11,1.82-.91,2.28-.17c.27.44.11,1,.39,1.49.49.75,1.66.28,2.38-.25s1.88-1,2.39-.28a3.45,3.45,0,0,1,.28.78c.34,1,1.41,1.48,2.24,2.11s1.49,1.89.79,2.67c-.35.38-1,.53-1.13,1s.4,1.15.89,1.57c.82.69,1,2.78-.11,3.34-.45.24-1.12.32-1.23.82s.35.79.65,1.14a2.15,2.15,0,0,1-.65,3.2c-.26.12-.58.22-.68.49a1.07,1.07,0,0,0,.06.61,3,3,0,0,1,.11,1.16.52.52,0,0,1-.14.36.58.58,0,0,1-.35.1c-1.56.07-2.31-.49-3.26.87a1.1,1.1,0,0,1-.33.35,1,1,0,0,1-.43.1c-1.07.09-1.77-.58-2.75-.7-1.36-.18-1.65.53-2.85,1.09C78.09,218.89,77.18,218.34,76.83,217.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.66,225s3.9,5.52,5.25,7.27,8.08,12.66,9,19.88c.1.77.19,1.43.29,2-2.9,19.12-2.45,92.1-2.34,98.09h11.88c-2.26-44.86-1.84-106.49-1.56-108.37s4.14-9.59,10.07-12.71,11-13.44,11-13.44h-1.89s-3.5,6.32-8.49,9.83a18.86,18.86,0,0,1-2.24,1.33,31.75,31.75,0,0,0-2-11.16l-1,.94c1.38,5.64,1.2,9.25.78,11.32a20.51,20.51,0,0,0-5.15,3.45c-5.17-6.72-8.08-22.09-8.08-22.09l-1.32.72a78.42,78.42,0,0,0,1.71,9.43,154,154,0,0,0,5.14,14.87,34.61,34.61,0,0,0-3.9,7.33,3,3,0,0,0-.5-.6c-3.37-3.05-9.7-17.43-9.7-17.43-1.53-3.34.81-12.12.81-12.12H85.7l-.79,7.68-4.44-4.85-.81.67,4.71,6.06,2.43,7.68-6.33-7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.51,242a4.46,4.46,0,0,0,.16-1c.13-2.16,2.19-1.82,3.95-2.11,1.37-.23-2.26-3.69.5-4.81a2.45,2.45,0,0,0,1.34-.93,1.58,1.58,0,0,0-.61-1.92,3.76,3.76,0,0,0-2.1-.53c-.45-.54-.08-1.37.36-1.93s1-1.2.8-1.89c-.25-1-1.7-1.08-2.76-.87a7.59,7.59,0,0,1-.57-2.14c-.19-.71-.76-1.47-1.49-1.38s-1.12.87-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.17c-.26.42-.1,1-.37,1.4-.46.7-1.55.27-2.22-.23s-1.76-1-2.23-.26a3,3,0,0,0-.27.72c-.32.92-1.31,1.38-2.09,2s-1.4,1.77-.74,2.49c.33.36.9.5,1.06.95s-.38,1.08-.84,1.47c-.76.65-.9,2.6.11,3.13.42.22,1,.29,1.15.76s-.33.74-.61,1.06a2,2,0,0,0,.61,3c.24.12.54.22.63.47a1,1,0,0,1-.06.56,2.85,2.85,0,0,0-.09,1.09.48.48,0,0,0,.13.34.55.55,0,0,0,.32.09c1.46.06,2.16-.46,3.05.81a1.2,1.2,0,0,0,.3.33,1,1,0,0,0,.41.1c1,.08,1.66-.55,2.57-.66,1.27-.17,1.54.49,2.66,1C430.33,243.71,431.18,243.2,431.51,242Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,240.18a6.14,6.14,0,0,0,.16-1c.12-2.16,2.19-1.82,3.94-2.12,1.38-.22-2.26-3.69.51-4.81a2.38,2.38,0,0,0,1.33-.93,1.56,1.56,0,0,0-.6-1.91,3.64,3.64,0,0,0-2.1-.53c-.45-.55-.08-1.37.35-1.94s1-1.19.81-1.88c-.25-1.05-1.71-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.86-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.11,1-.37,1.39-.46.71-1.55.27-2.23-.23s-1.75-1-2.23-.26a3.32,3.32,0,0,0-.26.73c-.32.92-1.32,1.38-2.09,2s-1.4,1.77-.74,2.49c.32.36.9.5,1.06,1s-.38,1.08-.84,1.47c-.77.65-.9,2.59.11,3.12.42.23,1,.29,1.15.76s-.33.75-.62,1.07a2,2,0,0,0,.62,3c.24.11.54.21.63.46a1,1,0,0,1-.06.57,3,3,0,0,0-.1,1.08.51.51,0,0,0,.13.34.53.53,0,0,0,.33.09c1.45.07,2.16-.45,3.05.82a.92.92,0,0,0,.3.32,1,1,0,0,0,.4.1c1,.08,1.66-.54,2.58-.66,1.27-.16,1.54.49,2.66,1C413.52,241.89,414.38,241.38,414.71,240.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.09,229.48a6.14,6.14,0,0,0,.16-1c.13-2.17,2.19-1.82,3.94-2.12,1.38-.23-2.26-3.69.51-4.81a2.42,2.42,0,0,0,1.33-.93,1.57,1.57,0,0,0-.6-1.92,3.69,3.69,0,0,0-2.1-.52c-.45-.55-.08-1.38.35-1.94s1-1.19.81-1.88c-.25-1-1.71-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.86-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.11,1-.37,1.39-.46.71-1.55.27-2.23-.23s-1.75-.95-2.23-.26a3.42,3.42,0,0,0-.26.72c-.32.93-1.32,1.39-2.09,2s-1.4,1.77-.74,2.49c.33.36.9.5,1.06,1s-.38,1.08-.84,1.47c-.76.65-.9,2.59.11,3.12.42.23,1,.29,1.15.76s-.33.75-.62,1.07a2,2,0,0,0,.62,3c.24.11.54.21.63.46a1,1,0,0,1-.06.57,3,3,0,0,0-.1,1.08.52.52,0,0,0,.14.34.55.55,0,0,0,.32.09c1.45.06,2.16-.45,3.05.82a.92.92,0,0,0,.3.32,1,1,0,0,0,.41.1c1,.08,1.65-.54,2.57-.66,1.27-.16,1.54.49,2.66,1C411.9,231.19,412.76,230.68,413.09,229.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,234.81a4.63,4.63,0,0,0,.16-1c.13-2.17,2.19-1.82,3.95-2.12,1.37-.23-2.26-3.69.5-4.81a2.45,2.45,0,0,0,1.34-.93,1.59,1.59,0,0,0-.61-1.92,3.67,3.67,0,0,0-2.1-.52c-.45-.55-.08-1.38.36-1.94s1-1.19.8-1.88c-.25-1.05-1.7-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.86-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.1,1-.37,1.39-.46.71-1.55.27-2.22-.23s-1.76-.95-2.23-.26a3,3,0,0,0-.27.72c-.32.93-1.31,1.39-2.09,2s-1.4,1.77-.74,2.49c.33.36.9.5,1.06,1s-.38,1.07-.84,1.47c-.76.65-.9,2.59.11,3.12.42.23,1.05.29,1.15.76s-.33.75-.61,1.07a2,2,0,0,0,.61,3c.24.11.54.21.63.46a1,1,0,0,1-.06.57,2.82,2.82,0,0,0-.09,1.08.47.47,0,0,0,.13.34.55.55,0,0,0,.32.09c1.46.06,2.16-.45,3.05.82a1.15,1.15,0,0,0,.3.32,1,1,0,0,0,.41.1c1,.08,1.66-.54,2.57-.66,1.27-.16,1.54.49,2.66,1C400.84,236.52,401.69,236,402,234.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,232.35a4.63,4.63,0,0,0,.16-1c.13-2.16,2.19-1.81,3.95-2.11,1.37-.23-2.26-3.69.51-4.81a2.42,2.42,0,0,0,1.33-.93,1.57,1.57,0,0,0-.6-1.92,3.71,3.71,0,0,0-2.1-.52c-.45-.55-.09-1.38.35-1.94s1-1.19.81-1.89c-.25-1-1.71-1.08-2.76-.87a7.27,7.27,0,0,1-.57-2.14c-.19-.71-.76-1.46-1.5-1.37s-1.11.86-1.79,1-1.47-.51-2.09-1-1.7-.85-2.13-.16c-.25.41-.1,1-.37,1.39-.45.7-1.54.27-2.22-.23s-1.75-.95-2.23-.26a2.58,2.58,0,0,0-.26.72c-.32.93-1.32,1.39-2.1,2s-1.39,1.77-.73,2.49c.32.36.89.5,1.05,1s-.38,1.07-.83,1.46c-.77.65-.91,2.6.1,3.13.43.22,1.05.29,1.15.76s-.33.74-.61,1.07a2,2,0,0,0,.61,3c.25.11.54.21.63.46a.94.94,0,0,1,0,.57,2.82,2.82,0,0,0-.1,1.08.51.51,0,0,0,.13.34.59.59,0,0,0,.32.09c1.46.06,2.16-.45,3.05.82a1.18,1.18,0,0,0,.31.32.91.91,0,0,0,.4.1c1,.08,1.66-.54,2.58-.66,1.27-.16,1.54.49,2.66,1C389.65,234.06,390.5,233.55,390.83,232.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,244.31a3.84,3.84,0,0,0,.12-.82c.1-1.7,1.73-1.43,3.11-1.66,1.08-.18-1.78-2.91.4-3.79a1.94,1.94,0,0,0,1.05-.73,1.24,1.24,0,0,0-.47-1.51,2.9,2.9,0,0,0-1.66-.42c-.35-.43-.06-1.08.28-1.52s.76-.94.63-1.49c-.19-.82-1.34-.85-2.17-.69a5.78,5.78,0,0,1-.45-1.68c-.15-.56-.59-1.15-1.17-1.08s-.88.68-1.42.81-1.16-.41-1.64-.82-1.34-.67-1.68-.13c-.2.33-.08.78-.29,1.1-.36.56-1.22.21-1.75-.18s-1.38-.75-1.75-.2a2,2,0,0,0-.21.57c-.25.72-1,1.08-1.65,1.55s-1.1,1.39-.58,2c.26.28.71.4.83.76s-.3.84-.66,1.15c-.6.51-.71,2,.09,2.46.33.18.82.23.9.6s-.26.59-.48.84a1.58,1.58,0,0,0,.48,2.35c.2.1.43.17.5.37a.78.78,0,0,1,0,.45,2.2,2.2,0,0,0-.08.85.43.43,0,0,0,.1.27.55.55,0,0,0,.25.07c1.15.05,1.71-.36,2.41.64a.86.86,0,0,0,.24.26.82.82,0,0,0,.31.07c.79.07,1.31-.42,2-.52,1-.12,1.22.39,2.1.81C389.76,245.66,390.43,245.26,390.69,244.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.42,240.18a4.63,4.63,0,0,0,.16-1c.13-2.16,2.19-1.82,3.95-2.12,1.37-.22-2.26-3.69.5-4.81a2.4,2.4,0,0,0,1.34-.93,1.57,1.57,0,0,0-.61-1.91,3.6,3.6,0,0,0-2.1-.53c-.45-.55-.08-1.37.36-1.94s1-1.19.8-1.88c-.25-1.05-1.71-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.86-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.1,1-.37,1.39-.46.71-1.55.27-2.22-.23s-1.76-1-2.23-.26a2.89,2.89,0,0,0-.27.73c-.32.92-1.31,1.38-2.09,2s-1.4,1.77-.74,2.49c.33.36.9.5,1.06,1s-.38,1.08-.84,1.47c-.76.65-.9,2.59.11,3.12.42.23,1,.29,1.15.76s-.33.75-.61,1.07a2,2,0,0,0,.61,3c.24.11.54.21.63.46a1,1,0,0,1-.06.57A2.82,2.82,0,0,0,372,239a.47.47,0,0,0,.13.34.48.48,0,0,0,.32.09c1.46.07,2.16-.45,3,.82a1.15,1.15,0,0,0,.3.32,1,1,0,0,0,.41.1c1,.08,1.66-.54,2.57-.66,1.27-.16,1.54.49,2.66,1C383.24,241.89,384.09,241.38,384.42,240.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,221.65a4.63,4.63,0,0,0,.16-1.05c.13-2.16,2.19-1.82,3.95-2.11,1.37-.23-2.26-3.69.5-4.81a2.45,2.45,0,0,0,1.34-.93,1.59,1.59,0,0,0-.61-1.92,3.67,3.67,0,0,0-2.1-.52c-.45-.55-.08-1.38.36-1.94s1-1.2.8-1.89c-.25-1-1.7-1.08-2.76-.87a7.59,7.59,0,0,1-.57-2.14c-.19-.71-.76-1.46-1.49-1.37s-1.12.86-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.1,1-.37,1.39-.46.7-1.55.27-2.22-.23s-1.76-1-2.23-.26a3,3,0,0,0-.27.72c-.32.93-1.31,1.39-2.09,2s-1.4,1.77-.74,2.49c.33.36.9.5,1.06,1s-.38,1.07-.84,1.46c-.76.65-.9,2.6.11,3.13.42.22,1.05.29,1.15.76s-.33.74-.61,1.07a2,2,0,0,0,.61,3c.24.11.54.21.63.46a.91.91,0,0,1-.06.56,2.87,2.87,0,0,0-.09,1.09.47.47,0,0,0,.13.34.55.55,0,0,0,.32.09c1.46.06,2.16-.45,3.05.82a1.31,1.31,0,0,0,.3.32,1,1,0,0,0,.41.1c1,.08,1.66-.54,2.57-.66,1.27-.16,1.54.49,2.66,1C400.84,223.36,401.69,222.85,402,221.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,222.38a4.54,4.54,0,0,0,.16-1c.13-2.16,2.19-1.82,3.95-2.11,1.37-.23-2.26-3.7.5-4.82a2.4,2.4,0,0,0,1.34-.93,1.57,1.57,0,0,0-.61-1.91,3.6,3.6,0,0,0-2.1-.53c-.45-.55-.08-1.37.36-1.93s1-1.2.8-1.89c-.25-1-1.7-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.87-1.79,1-1.48-.52-2.09-1-1.71-.85-2.13-.16c-.26.41-.1,1-.37,1.39-.46.71-1.55.27-2.22-.23s-1.76-.95-2.23-.26a3,3,0,0,0-.27.73c-.32.92-1.31,1.38-2.09,2s-1.39,1.77-.74,2.5c.33.35.9.5,1.06,1s-.38,1.08-.84,1.47c-.76.65-.9,2.59.11,3.12.42.23,1.05.3,1.15.76s-.33.75-.61,1.07a2,2,0,0,0,.61,3c.24.12.54.21.63.47a.85.85,0,0,1-.06.56,2.82,2.82,0,0,0-.09,1.08.39.39,0,0,0,.45.43c1.46.07,2.16-.45,3.05.82a1.05,1.05,0,0,0,.31.32.91.91,0,0,0,.4.1c1,.09,1.66-.54,2.57-.66,1.27-.16,1.54.5,2.66,1C415.21,224.09,416.06,223.58,416.39,222.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.12,228.26a5.05,5.05,0,0,0,.16-1c.13-2.16,2.19-1.82,4-2.11,1.37-.23-2.26-3.7.5-4.81a2.54,2.54,0,0,0,1.34-.93,1.58,1.58,0,0,0-.61-1.92,3.7,3.7,0,0,0-2.1-.53c-.45-.55-.08-1.37.36-1.93s1-1.2.8-1.89c-.25-1-1.71-1.08-2.76-.88a7.62,7.62,0,0,1-.57-2.13c-.19-.72-.76-1.47-1.49-1.38s-1.12.87-1.8,1-1.47-.51-2.09-1-1.7-.85-2.12-.16c-.26.41-.1,1-.37,1.4-.46.7-1.55.26-2.23-.24s-1.75-.95-2.22-.25a3,3,0,0,0-.27.72c-.32.92-1.32,1.38-2.09,2s-1.4,1.77-.74,2.5c.33.35.9.5,1.06,1s-.38,1.08-.84,1.47c-.76.65-.9,2.59.11,3.13.42.22,1,.29,1.15.76s-.33.74-.61,1.06a2,2,0,0,0,.61,3c.24.12.54.21.63.47a1,1,0,0,1-.06.56,2.82,2.82,0,0,0-.09,1.08.45.45,0,0,0,.13.34.44.44,0,0,0,.32.09c1.46.07,2.16-.45,3.05.82a1.15,1.15,0,0,0,.3.32,1,1,0,0,0,.41.1c1,.09,1.66-.54,2.57-.66,1.27-.16,1.54.5,2.66,1C423.94,230,424.79,229.46,425.12,228.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47,235.7s-3.65,5.16-4.91,6.79-7.55,11.84-8.4,18.58c-.1.72-.19,1.34-.27,1.88,2.7,17.87,2.28,86.09,2.18,91.68H400c2.11-41.92,1.72-99.53,1.45-101.29s-3.87-9-9.41-11.88-10.32-12.56-10.32-12.56h1.76s3.27,5.91,7.93,9.19a18.64,18.64,0,0,0,2.1,1.24,29.68,29.68,0,0,1,1.85-10.43l.95.88c-1.28,5.27-1.11,8.64-.73,10.58a19,19,0,0,1,4.82,3.22c4.83-6.28,7.55-20.64,7.55-20.64l1.24.67a74.89,74.89,0,0,1-1.6,8.81c-.91,3.72-3.57,10.72-4.81,13.9a33.22,33.22,0,0,1,3.65,6.85,2.54,2.54,0,0,1,.47-.56c3.14-2.84,9.06-16.29,9.06-16.29,1.43-3.12-.76-11.32-.76-11.32h1.65l.74,7.17,4.16-4.53.75.63-4.4,5.66-2.27,7.18,5.92-6.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.64,210a6.62,6.62,0,0,0,.2-1.36c.17-2.82,2.86-2.37,5.15-2.75,1.79-.3-2.95-4.82.66-6.28a3.15,3.15,0,0,0,1.74-1.22,2,2,0,0,0-.78-2.5,4.81,4.81,0,0,0-2.74-.68c-.59-.72-.11-1.8.46-2.53s1.27-1.56,1.05-2.46c-.33-1.36-2.23-1.41-3.6-1.15a9.93,9.93,0,0,1-.75-2.78c-.24-.93-1-1.91-1.94-1.8s-1.46,1.13-2.34,1.34-1.92-.67-2.73-1.35-2.22-1.11-2.78-.21c-.33.54-.13,1.29-.48,1.82-.6.92-2,.35-2.9-.3s-2.29-1.24-2.91-.34a3.91,3.91,0,0,0-.34.94c-.42,1.21-1.72,1.81-2.74,2.58s-1.81,2.31-.95,3.25c.42.47,1.16.66,1.37,1.25.27.74-.49,1.41-1.09,1.91-1,.85-1.18,3.39.14,4.08.55.3,1.37.39,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.8,3.9c.32.15.71.27.83.6a1.27,1.27,0,0,1-.08.74,4,4,0,0,0-.13,1.41.51.51,0,0,0,.59.56c1.91.09,2.83-.58,4,1.07a1.31,1.31,0,0,0,.39.42,1.22,1.22,0,0,0,.53.13c1.31.11,2.16-.7,3.36-.86,1.66-.21,2,.65,3.47,1.33C297.09,212.24,298.21,211.57,298.64,210Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.71,207.63a6.59,6.59,0,0,0,.21-1.36c.17-2.82,2.86-2.37,5.15-2.75,1.79-.3-2.95-4.82.66-6.28a3.18,3.18,0,0,0,1.74-1.21,2.05,2.05,0,0,0-.79-2.51,4.77,4.77,0,0,0-2.73-.68c-.59-.72-.11-1.8.46-2.53s1.26-1.56,1-2.46c-.33-1.36-2.23-1.41-3.6-1.14a10,10,0,0,1-.75-2.79c-.25-.93-1-1.91-1.95-1.8s-1.45,1.13-2.34,1.34-1.92-.66-2.73-1.35-2.21-1.11-2.77-.21c-.33.54-.13,1.29-.48,1.82-.6.92-2,.35-2.9-.3s-2.29-1.24-2.91-.34a3.91,3.91,0,0,0-.34.94c-.42,1.21-1.72,1.81-2.74,2.58s-1.82,2.31-1,3.26c.43.46,1.17.65,1.38,1.24.26.74-.49,1.41-1.09,1.92-1,.84-1.18,3.38.14,4.08.55.29,1.36.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.8,3.9c.32.15.71.27.82.61a1.16,1.16,0,0,1-.07.73,4,4,0,0,0-.13,1.41.69.69,0,0,0,.17.45.74.74,0,0,0,.42.12c1.9.08,2.82-.59,4,1.06a1.34,1.34,0,0,0,.4.42,1.07,1.07,0,0,0,.53.13c1.3.11,2.16-.7,3.36-.86,1.65-.21,2,.65,3.47,1.33C275.17,209.87,276.28,209.2,276.71,207.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,193.67a6.59,6.59,0,0,0,.21-1.36c.16-2.82,2.86-2.37,5.15-2.75,1.79-.3-2.95-4.82.66-6.28a3.15,3.15,0,0,0,1.74-1.22,2.05,2.05,0,0,0-.79-2.5,4.87,4.87,0,0,0-2.74-.69c-.59-.71-.11-1.79.46-2.52s1.27-1.56,1-2.46c-.32-1.36-2.22-1.41-3.6-1.15A9.59,9.59,0,0,1,276,170c-.25-.93-1-1.92-1.95-1.8s-1.46,1.13-2.34,1.34-1.92-.67-2.73-1.35-2.22-1.11-2.77-.21c-.34.54-.14,1.29-.48,1.82-.6.92-2,.35-2.91-.3s-2.28-1.24-2.9-.34a3.55,3.55,0,0,0-.35.94c-.41,1.21-1.72,1.81-2.73,2.58s-1.82,2.31-1,3.25c.42.47,1.17.66,1.38,1.25.26.74-.5,1.4-1.1,1.91-1,.85-1.17,3.39.15,4.08.55.29,1.36.38,1.5,1s-.44,1-.8,1.4a2.61,2.61,0,0,0,.8,3.9c.31.15.7.27.82.6a1.27,1.27,0,0,1-.08.74,4,4,0,0,0-.12,1.41.5.5,0,0,0,.59.56c1.9.09,2.82-.59,4,1.07a1.34,1.34,0,0,0,.4.42,1.14,1.14,0,0,0,.52.13c1.31.11,2.17-.71,3.36-.86,1.66-.21,2,.65,3.48,1.33C273.05,195.9,274.17,195.24,274.6,193.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.16,200.63a6.72,6.72,0,0,0,.2-1.36c.17-2.82,2.86-2.38,5.16-2.76,1.79-.3-2.95-4.82.65-6.28a3.21,3.21,0,0,0,1.75-1.21,2.05,2.05,0,0,0-.79-2.5,4.79,4.79,0,0,0-2.74-.69c-.59-.72-.11-1.79.46-2.52s1.27-1.57,1-2.47c-.32-1.36-2.23-1.41-3.6-1.14a9.57,9.57,0,0,1-.74-2.79c-.25-.93-1-1.91-1.95-1.79s-1.46,1.13-2.34,1.33-1.92-.66-2.73-1.35-2.22-1.1-2.77-.2c-.34.53-.14,1.28-.48,1.81-.6.92-2,.35-2.91-.3s-2.29-1.24-2.91-.34a3.84,3.84,0,0,0-.34,1c-.42,1.2-1.72,1.8-2.73,2.58s-1.82,2.3-1,3.25c.42.46,1.17.65,1.38,1.24.26.74-.5,1.41-1.1,1.92-1,.85-1.17,3.38.14,4.08.56.29,1.37.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.81,3.9c.31.15.7.28.82.61a1.24,1.24,0,0,1-.08.73,3.77,3.77,0,0,0-.12,1.42.6.6,0,0,0,.17.44.67.67,0,0,0,.42.12c1.9.08,2.82-.59,4,1.07a1.45,1.45,0,0,0,.4.42,1.29,1.29,0,0,0,.52.13c1.31.11,2.17-.71,3.36-.86,1.66-.22,2,.64,3.47,1.33C258.61,202.86,259.73,202.19,260.16,200.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,197.41a6.48,6.48,0,0,0,.21-1.36c.17-2.82,2.86-2.37,5.15-2.75,1.79-.3-2.95-4.82.66-6.28a3.18,3.18,0,0,0,1.74-1.21,2.05,2.05,0,0,0-.79-2.51,4.77,4.77,0,0,0-2.73-.68c-.59-.72-.11-1.8.45-2.53s1.27-1.56,1.06-2.46c-.33-1.36-2.23-1.41-3.61-1.14a10.34,10.34,0,0,1-.74-2.79c-.25-.93-1-1.91-2-1.8s-1.45,1.13-2.34,1.34-1.92-.66-2.73-1.35-2.21-1.11-2.77-.21c-.33.54-.13,1.29-.48,1.82-.6.92-2,.35-2.9-.3s-2.29-1.24-2.91-.34a3.84,3.84,0,0,0-.34.95c-.42,1.2-1.72,1.8-2.74,2.57s-1.82,2.31-1,3.26c.42.46,1.17.65,1.38,1.24.26.74-.49,1.41-1.09,1.92-1,.84-1.18,3.38.14,4.08.55.29,1.36.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.8,3.9c.32.15.71.28.82.61a1.24,1.24,0,0,1-.07.73,3.74,3.74,0,0,0-.13,1.41.69.69,0,0,0,.17.45.74.74,0,0,0,.42.12c1.9.08,2.82-.59,4,1.06a1.34,1.34,0,0,0,.4.42,1.19,1.19,0,0,0,.53.14c1.3.1,2.16-.71,3.35-.87,1.66-.21,2,.65,3.48,1.34C244,199.65,245.13,199,245.56,197.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.37,213a4.91,4.91,0,0,0,.16-1.07c.14-2.22,2.26-1.87,4.06-2.17,1.41-.24-2.32-3.8.52-4.95a2.47,2.47,0,0,0,1.37-1,1.6,1.6,0,0,0-.62-2,3.73,3.73,0,0,0-2.16-.54c-.46-.57-.08-1.42.37-2s1-1.23.82-1.94c-.25-1.07-1.75-1.11-2.83-.9a8.06,8.06,0,0,1-.59-2.19c-.19-.74-.78-1.51-1.53-1.42s-1.15.89-1.84,1.05-1.52-.52-2.15-1.06-1.75-.87-2.19-.16c-.26.42-.1,1-.37,1.43-.48.72-1.59.27-2.29-.24s-1.8-1-2.29-.27a3.19,3.19,0,0,0-.27.75c-.33.95-1.35,1.42-2.15,2s-1.43,1.82-.76,2.56c.33.36.92.51,1.09,1s-.39,1.11-.86,1.51c-.79.66-.93,2.66.11,3.21.43.23,1.07.3,1.18.78s-.34.76-.63,1.1a2.06,2.06,0,0,0,.63,3.07c.25.12.56.21.65.47a1.06,1.06,0,0,1-.06.58,3,3,0,0,0-.1,1.12.56.56,0,0,0,.13.35.63.63,0,0,0,.33.09c1.5.07,2.22-.47,3.14.84a1.22,1.22,0,0,0,.31.33,1,1,0,0,0,.42.1c1,.09,1.7-.55,2.64-.67,1.31-.17,1.58.5,2.73,1C244.16,214.78,245,214.26,245.37,213Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,207.63a6.59,6.59,0,0,0,.21-1.36c.17-2.82,2.86-2.37,5.15-2.75,1.79-.3-3-4.82.66-6.28A3.18,3.18,0,0,0,245,196a2.06,2.06,0,0,0-.78-2.51,4.81,4.81,0,0,0-2.74-.68c-.59-.72-.11-1.8.46-2.53s1.26-1.56,1.05-2.46c-.33-1.36-2.23-1.41-3.6-1.14a10,10,0,0,1-.75-2.79c-.24-.93-1-1.91-2-1.8s-1.45,1.13-2.34,1.34-1.92-.66-2.72-1.35-2.22-1.11-2.78-.21c-.33.54-.13,1.29-.48,1.82-.6.92-2,.35-2.9-.3s-2.29-1.24-2.91-.34a3.91,3.91,0,0,0-.34.94c-.42,1.21-1.72,1.81-2.74,2.58s-1.82,2.31-1,3.26c.43.46,1.17.65,1.38,1.24.26.74-.49,1.41-1.09,1.92-1,.84-1.18,3.38.14,4.08.55.29,1.36.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.8,3.9c.32.15.71.27.82.61a1.16,1.16,0,0,1-.07.73,4,4,0,0,0-.13,1.41.69.69,0,0,0,.17.45.74.74,0,0,0,.42.12c1.9.08,2.82-.59,4,1.06a1.34,1.34,0,0,0,.4.42,1.09,1.09,0,0,0,.53.13c1.31.11,2.16-.7,3.36-.86,1.66-.21,2,.65,3.47,1.33C235.65,209.87,236.76,209.2,237.19,207.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.16,183.45a6.62,6.62,0,0,0,.2-1.36c.17-2.82,2.86-2.37,5.16-2.75,1.79-.3-2.95-4.82.65-6.28a3.17,3.17,0,0,0,1.75-1.22,2.05,2.05,0,0,0-.79-2.5,4.79,4.79,0,0,0-2.74-.68c-.59-.72-.11-1.8.46-2.53s1.27-1.56,1-2.46c-.32-1.36-2.23-1.41-3.6-1.15a9.59,9.59,0,0,1-.74-2.78c-.25-.93-1-1.91-1.95-1.8s-1.46,1.13-2.34,1.34-1.92-.67-2.73-1.35-2.22-1.11-2.77-.21c-.34.54-.14,1.29-.48,1.82-.6.92-2,.35-2.91-.3s-2.29-1.24-2.91-.34a3.91,3.91,0,0,0-.34.94c-.42,1.21-1.72,1.81-2.73,2.58s-1.82,2.31-1,3.25c.42.47,1.17.66,1.38,1.25.26.74-.5,1.4-1.1,1.91-1,.85-1.17,3.39.14,4.08.56.3,1.37.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.81,3.9c.31.15.7.27.82.6a1.27,1.27,0,0,1-.08.74A3.74,3.74,0,0,0,244,182a.6.6,0,0,0,.17.45.66.66,0,0,0,.42.11c1.9.09,2.82-.58,4,1.07a1.34,1.34,0,0,0,.4.42,1.14,1.14,0,0,0,.52.13c1.31.11,2.17-.71,3.36-.86,1.66-.21,2,.65,3.47,1.33C258.61,185.68,259.73,185,260.16,183.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,184.41a6.7,6.7,0,0,0,.21-1.36c.16-2.82,2.86-2.37,5.15-2.76,1.79-.29-2.95-4.81.66-6.27a3.18,3.18,0,0,0,1.74-1.22,2.05,2.05,0,0,0-.79-2.5,4.87,4.87,0,0,0-2.74-.69c-.59-.71-.11-1.79.46-2.52s1.27-1.56,1-2.46c-.32-1.36-2.22-1.41-3.6-1.15a9.59,9.59,0,0,1-.74-2.78c-.25-.94-1-1.92-1.95-1.8S276.9,160,276,160.24s-1.92-.67-2.73-1.35-2.22-1.11-2.77-.21c-.34.54-.14,1.29-.48,1.82-.6.92-2,.35-2.91-.3s-2.29-1.25-2.91-.34a3.77,3.77,0,0,0-.34.94c-.42,1.21-1.72,1.81-2.73,2.58s-1.82,2.31-1,3.25c.42.47,1.17.66,1.38,1.25.26.74-.5,1.4-1.1,1.91-1,.85-1.17,3.39.14,4.08.56.29,1.37.38,1.5,1s-.43,1-.8,1.4a2.62,2.62,0,0,0,.81,3.9c.31.15.7.27.82.6a1.27,1.27,0,0,1-.08.74,3.74,3.74,0,0,0-.12,1.41.62.62,0,0,0,.17.45.66.66,0,0,0,.42.11c1.9.09,2.82-.59,4,1.07a1.34,1.34,0,0,0,.4.42,1.14,1.14,0,0,0,.52.13c1.31.11,2.17-.71,3.36-.86,1.66-.21,2,.65,3.47,1.33C277.36,186.64,278.48,186,278.91,184.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3,192.08a6.52,6.52,0,0,0,.2-1.36c.17-2.82,2.86-2.37,5.16-2.75,1.79-.3-3-4.82.65-6.28a3.21,3.21,0,0,0,1.75-1.21,2.07,2.07,0,0,0-.79-2.51,4.87,4.87,0,0,0-2.74-.68c-.59-.72-.11-1.79.46-2.53s1.27-1.56,1.05-2.46c-.32-1.36-2.23-1.41-3.6-1.14a9.66,9.66,0,0,1-.74-2.79c-.25-.93-1-1.91-1.95-1.8s-1.46,1.13-2.34,1.34c-1,.25-1.92-.66-2.73-1.35s-2.22-1.11-2.77-.21c-.34.54-.14,1.29-.48,1.82-.6.92-2,.35-2.91-.3s-2.29-1.24-2.91-.34a3.84,3.84,0,0,0-.34.95c-.42,1.2-1.72,1.8-2.73,2.57s-1.82,2.31-1,3.26c.42.46,1.17.65,1.38,1.24s-.5,1.41-1.1,1.92c-1,.84-1.17,3.38.14,4.08.56.29,1.37.38,1.5,1s-.43,1-.8,1.39a2.62,2.62,0,0,0,.81,3.9c.31.15.7.28.82.61a1.24,1.24,0,0,1-.08.73,3.77,3.77,0,0,0-.12,1.42.6.6,0,0,0,.17.44.74.74,0,0,0,.42.12c1.9.08,2.82-.59,4,1.06a1.37,1.37,0,0,0,.4.43,1.29,1.29,0,0,0,.52.13c1.31.1,2.16-.71,3.36-.87,1.66-.21,2,.65,3.47,1.34C288.75,194.32,289.87,193.65,290.3,192.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,201.78s-4.77,6.74-6.41,8.87-9.85,15.44-11,24.24c-.12.94-.24,1.75-.35,2.45,3.53,23.32,3,117.49,2.85,124.8h-15.8c1.73-72.14,3.56-135,3.2-137.33s-5-11.69-12.27-15.5-13.47-16.4-13.47-16.4h2.3s4.27,7.72,10.35,12a22.27,22.27,0,0,0,2.73,1.62,38.74,38.74,0,0,1,2.42-13.61l1.24,1.15c-1.68,6.88-1.46,11.28-.95,13.81a25,25,0,0,1,6.29,4.21c6.3-8.2,9.84-27,9.84-27l1.62.89a96,96,0,0,1-2.09,11.49c-1.18,4.85-4.65,14-6.27,18.14a42.91,42.91,0,0,1,4.76,8.94,3.64,3.64,0,0,1,.61-.73c4.11-3.72,11.83-21.26,11.83-21.26,1.86-4.07-1-14.78-1-14.78h2.15l1,9.36,5.42-5.91,1,.82-5.75,7.39-3,9.37,7.72-8.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 324.97,
    width: 125.59,
    height: 57.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.31,
    y: 324.97,
    width: 64.5,
    height: 57.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.82,
    y: 339.9,
    width: 15.91,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.82,
    y: 339.9,
    width: 14.45,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.39,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.39,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.39 352.95 406.14 352.95 402.88 365.13 402.39 365.13 402.39 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.63 339.9 406.37 352.07 402.5 352.07 405.76 339.9 409.63 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.97 352.95 409.25 352.95 406 365.13 404.72 365.13 407.97 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.75 339.9 409.49 352.07 408.21 352.07 411.47 339.9 412.75 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.13 352.95 426 352.95 422.74 365.13 418.87 365.13 422.13 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.3 339.9 429.3 340.62 426.24 352.07 422.37 352.07 425.63 339.9 429.3 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.84 352.95 429.12 352.95 425.86 365.13 424.58 365.13 427.84 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.3 347.49 429.3 352.07 428.07 352.07 429.3 347.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.66,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.66,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.93,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.93,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.66 339.9 344.66 345.92 346.27 339.9 344.66 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.66 352.95 344.66 357.57 345.9 352.95 344.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.4 339.9 346.14 352.07 344.86 352.07 348.12 339.9 349.4 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.52 352.95 358.78 352.95 355.52 365.13 359.38 365.13 360.52 360.89 360.52 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.52 346.46 359.02 352.07 360.52 352.07 360.52 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.8,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.8,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.07,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.07,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.8 339.9 318.8 345.92 320.41 339.9 318.8 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.8 352.95 318.8 357.57 320.04 352.95 318.8 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.54 339.9 320.28 352.07 319 352.07 322.26 339.9 323.54 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.66 352.95 332.92 352.95 329.66 365.13 333.52 365.13 334.66 360.89 334.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.66 346.46 333.16 352.07 334.66 352.07 334.66 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.43,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.97,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.29,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.83,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.47,
    y: 335.85,
    width: 31.86,
    height: 2.39,
    transform: "translate(832.8 674.09) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.47,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    transform: "translate(803.33 674.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.99 290.11 341.85 290.11 300.4 327.99 443.26 327.99 441.82 326.89 393.99 290.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.85 290.11 373.67 326.89 441.82 326.89 393.99 290.11 341.85 290.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.87,
    y: 325.48,
    width: 144.39,
    height: 3.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.06,
    y: 325.48,
    width: 69.2,
    height: 3.72,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.45 381.06 297.77 381.06 295.91 382.36 445.31 382.36 443.45 381.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.31,
    y: 324.97,
    width: 125.59,
    height: 57.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.31,
    y: 324.97,
    width: 64.5,
    height: 57.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 339.9,
    width: 15.91,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.82,
    y: 339.9,
    width: 14.45,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.39,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.39,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.28,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.28,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.39 352.95 286.14 352.95 282.88 365.13 282.39 365.13 282.39 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.63 339.9 286.37 352.07 282.5 352.07 285.76 339.9 289.63 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.97 352.95 289.25 352.95 286 365.13 284.72 365.13 287.97 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.75 339.9 289.49 352.07 288.21 352.07 291.47 339.9 292.75 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.13 352.95 306 352.95 302.74 365.13 298.87 365.13 302.13 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.3 339.9 309.3 340.62 306.24 352.07 302.37 352.07 305.63 339.9 309.3 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.84 352.95 309.12 352.95 305.86 365.13 304.58 365.13 307.84 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.3 347.49 309.3 352.07 308.07 352.07 309.3 347.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.66,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.66,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.93,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.93,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.66 339.9 224.66 345.92 226.27 339.9 224.66 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.66 352.95 224.66 357.57 225.9 352.95 224.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.4 339.9 226.14 352.07 224.86 352.07 228.12 339.9 229.4 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.52 352.95 238.78 352.95 235.52 365.13 239.38 365.13 240.52 360.89 240.52 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.52 346.46 239.02 352.07 240.52 352.07 240.52 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.8,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.07,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.07,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.8 339.9 198.8 345.92 200.41 339.9 198.8 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.8 352.95 198.8 357.57 200.04 352.95 198.8 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.54 339.9 200.28 352.07 199 352.07 202.26 339.9 203.54 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.66 352.95 212.92 352.95 209.66 365.13 213.53 365.13 214.66 360.89 214.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.66 346.46 213.16 352.07 214.66 352.07 214.66 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.43,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.97,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.29,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.83,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.47,
    y: 335.85,
    width: 31.86,
    height: 2.39,
    transform: "translate(592.8 674.09) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.47,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    transform: "translate(563.33 674.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.99 290.11 221.85 290.11 180.4 327.99 323.26 327.99 321.82 326.89 273.99 290.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.85 290.11 253.67 326.89 321.82 326.89 273.99 290.11 221.85 290.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.87,
    y: 325.48,
    width: 144.39,
    height: 3.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.06,
    y: 325.48,
    width: 69.2,
    height: 3.72,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.45 381.06 177.77 381.06 175.91 382.36 325.31 382.36 323.45 381.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.31,
    y: 324.97,
    width: 125.59,
    height: 57.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.31,
    y: 324.97,
    width: 64.5,
    height: 57.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 339.9,
    width: 15.91,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 339.9,
    width: 14.45,
    height: 42.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.39,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.39,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.28,
    y: 352.95,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.28,
    y: 339.9,
    width: 13.02,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.39 352.95 166.14 352.95 162.88 365.13 162.39 365.13 162.39 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.63 339.9 166.37 352.07 162.5 352.07 165.76 339.9 169.63 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.97 352.95 169.25 352.95 166 365.13 164.72 365.13 167.97 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.75 339.9 169.49 352.07 168.21 352.07 171.47 339.9 172.75 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.13 352.95 186 352.95 182.74 365.13 178.87 365.13 182.13 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.3 339.9 189.3 340.62 186.24 352.07 182.37 352.07 185.63 339.9 189.3 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.84 352.95 189.12 352.95 185.86 365.13 184.58 365.13 187.84 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.3 347.49 189.3 352.07 188.07 352.07 189.3 347.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.66,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.66,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.66 339.9 104.66 345.92 106.27 339.9 104.66 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.66 352.95 104.66 357.57 105.9 352.95 104.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.4 339.9 106.14 352.07 104.86 352.07 108.12 339.9 109.4 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.52 352.95 118.78 352.95 115.52 365.13 119.38 365.13 120.52 360.89 120.52 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.52 346.46 119.02 352.07 120.52 352.07 120.52 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.8,
    y: 352.95,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.8,
    y: 339.9,
    width: 7.39,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.07,
    y: 352.95,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.07,
    y: 339.9,
    width: 7.59,
    height: 12.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.8 339.9 78.8 345.92 80.41 339.9 78.8 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.8 352.95 78.8 357.57 80.04 352.95 78.8 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.54 339.9 80.28 352.07 79 352.07 82.26 339.9 83.54 339.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.66 352.95 92.92 352.95 89.66 365.13 93.53 365.13 94.66 360.89 94.66 352.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.66 346.46 93.16 352.07 94.66 352.07 94.66 346.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.43,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.97,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.29,
    y: 335.85,
    width: 18.93,
    height: 2.39,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.83,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.47,
    y: 335.85,
    width: 31.86,
    height: 2.39,
    transform: "translate(352.8 674.09) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.47,
    y: 335.85,
    width: 2.39,
    height: 2.39,
    transform: "translate(323.33 674.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.99 290.11 101.85 290.11 60.4 327.99 203.26 327.99 201.82 326.89 153.99 290.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.85 290.11 133.67 326.89 201.82 326.89 153.99 290.11 101.85 290.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.87,
    y: 325.48,
    width: 144.39,
    height: 3.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.06,
    y: 325.48,
    width: 69.2,
    height: 3.72,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.45 381.06 57.77 381.06 55.91 382.36 205.31 382.36 203.45 381.06",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-47"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-47",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "95.5 296.74 131.97 258.77 209 258.77 249.18 296.74 95.5 296.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.97 257.94 177.26 298.44 95.5 295.91 131.97 257.94",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 301.3,
    width: 136.56,
    height: 49.31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 301.3,
    width: 136.56,
    height: 49.31,
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 301.3,
    width: 80.46,
    height: 49.31,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.89,
    y: 308.32,
    width: 78.63,
    height: 29.05,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,308.32v29.05h78.62V308.32Zm75.43,26.31H150.68V311.55h72.64Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.89,
    y: 308.32,
    width: 29.69,
    height: 29.05,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 311.55,
    width: 66.6,
    height: 22.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 311.56,
    width: 66.61,
    height: 22.58,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.31,
    y: 311.55,
    width: 22.16,
    height: 22.58,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.61 311.56 165.56 334.14 157.31 334.14 163.36 311.56 171.61 311.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.92 311.56 219.92 331.32 219.16 334.14 210.92 334.14 216.96 311.56 219.92 311.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.51 311.56 170.47 334.14 168.09 334.14 174.13 311.56 176.51 311.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.63 311.56 208.58 334.14 207.39 334.14 213.43 311.56 214.63 311.56",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.59,
    y: 311.69,
    width: 40.25,
    height: 22.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 94.59,
    y: 311.69,
    width: 40.25,
    height: 22.72,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.59,
    y: 311.69,
    width: 40.25,
    height: 22.72,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.59 311.69 94.59 331.73 99.95 311.69 94.59 311.69",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.58 311.69 99.5 334.41 96.78 334.41 102.86 311.69 105.58 311.69",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.49,334.13h-50.7v1.63h2.31v15.29h1.25v-.9H182.9v.9h1.24v-.9h16.55v.9h1.25v-.9h16.84v.9H220v-.9h16.55v.9h1.25v-.9h16.55v.9h1.24V335.76h2.32v-1.63ZM182.9,349.72H166.35v-1.63H182.9Zm0-2.06H166.35V346H182.9Zm0-2.06H166.35V344H182.9Zm0-2.06H166.35V341.9H182.9Zm0-2.06H166.35v-1.64H182.9Zm0-2.06H166.35v-1.64H182.9Zm0-2.06H166.35v-1.6H182.9Zm17.79,12.36H184.14v-1.63h16.55Zm0-2.06H184.14V346h16.55Zm0-2.06H184.14V344h16.55Zm0-2.06H184.14V341.9h16.55Zm0-2.06H184.14v-1.64h16.55Zm0-2.06H184.14v-1.64h16.55Zm0-2.06H184.14v-1.6h16.55Zm18.09,12.36H201.94v-1.63h16.84Zm0-2.06H201.94V346h16.84Zm0-2.06H201.94V344h16.84Zm0-2.06H201.94V341.9h16.84Zm0-2.06H201.94v-1.64h16.84Zm0-2.06H201.94v-1.64h16.84Zm0-2.06H201.94v-1.6h16.84Zm17.79,12.36H220v-1.63h16.55Zm0-2.06H220V346h16.55Zm0-2.06H220V344h16.55Zm0-2.06H220V341.9h16.55Zm0-2.06H220v-1.64h16.55Zm0-2.06H220v-1.64h16.55Zm0-2.06H220v-1.6h16.55Zm17.8,12.36H237.82v-1.63h16.55Zm0-2.06H237.82V346h16.55Zm0-2.06H237.82V344h16.55Zm0-2.06H237.82V341.9h16.55Zm0-2.06H237.82v-1.64h16.55Zm0-2.06H237.82v-1.64h16.55Zm0-2.06H237.82v-1.6h16.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.49,334.13h-50.7v1.63h2.31v15.29h1.25v-.9H182.9v.9h1.24v-.9h16.55v.9h1.25v-.9h16.84v.9H220v-.9h16.55v.9h1.25v-.9h16.55v.9h1.24V335.76h2.32v-1.63ZM182.9,349.72H166.35v-1.63H182.9Zm0-2.06H166.35V346H182.9Zm0-2.06H166.35V344H182.9Zm0-2.06H166.35V341.9H182.9Zm0-2.06H166.35v-1.64H182.9Zm0-2.06H166.35v-1.64H182.9Zm0-2.06H166.35v-1.6H182.9Zm17.79,12.36H184.14v-1.63h16.55Zm0-2.06H184.14V346h16.55Zm0-2.06H184.14V344h16.55Zm0-2.06H184.14V341.9h16.55Zm0-2.06H184.14v-1.64h16.55Zm0-2.06H184.14v-1.64h16.55Zm0-2.06H184.14v-1.6h16.55Zm18.09,12.36H201.94v-1.63h16.84Zm0-2.06H201.94V346h16.84Zm0-2.06H201.94V344h16.84Zm0-2.06H201.94V341.9h16.84Zm0-2.06H201.94v-1.64h16.84Zm0-2.06H201.94v-1.64h16.84Zm0-2.06H201.94v-1.6h16.84Zm17.79,12.36H220v-1.63h16.55Zm0-2.06H220V346h16.55Zm0-2.06H220V344h16.55Zm0-2.06H220V341.9h16.55Zm0-2.06H220v-1.64h16.55Zm0-2.06H220v-1.64h16.55Zm0-2.06H220v-1.6h16.55Zm17.8,12.36H237.82v-1.63h16.55Zm0-2.06H237.82V346h16.55Zm0-2.06H237.82V344h16.55Zm0-2.06H237.82V341.9h16.55Zm0-2.06H237.82v-1.64h16.55Zm0-2.06H237.82v-1.64h16.55Zm0-2.06H237.82v-1.6h16.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.92,
    y: 353.61,
    width: 52.99,
    height: 57.64,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.92,
    y: 353.61,
    width: 52.99,
    height: 57.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.92,
    y: 350.61,
    width: 11.12,
    height: 60.73,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.92,
    y: 350.61,
    width: 11.12,
    height: 60.73,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.97,
    y: 356.24,
    width: 7.07,
    height: 55.1,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 352.54,
    width: 136.65,
    height: 58.8,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 352.54,
    width: 136.65,
    height: 58.8,
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.67,
    y: 352.54,
    width: 70.18,
    height: 58.8,
    style: {
      opacity: 0.05
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 127.16,
    y: 365.14,
    width: 26.34,
    height: 22.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.91,
    y: 365.14,
    width: 24.65,
    height: 22.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.91,
    y: 365.14,
    width: 24.65,
    height: 22.72,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.16,
    y: 365.14,
    width: 26.34,
    height: 22.72,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.16,
    y: 365.14,
    width: 26.34,
    height: 22.72,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.91,
    y: 365.14,
    width: 24.65,
    height: 22.72,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.67 365.14 111.58 387.86 102.11 387.86 108.19 365.14 117.67 365.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.29 365.14 117.21 387.86 114.49 387.86 120.57 365.14 123.29 365.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.5 367.41 153.5 387.86 148.03 387.86 153.5 367.41",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.49 387.86 232.49 365.14 237.32 365.14 237.32 361.18 201.66 361.18 201.66 391.88 237.32 391.88 237.32 387.86 232.49 387.86",
    style: {
      fill: "#407BFF"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.88,
    y: 365.14,
    width: 24.65,
    height: 22.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.88,
    y: 365.14,
    width: 24.65,
    height: 22.72,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.88,
    y: 365.14,
    width: 24.65,
    height: 22.72,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.63 365.14 219.55 387.86 210.08 387.86 216.16 365.14 225.63 365.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.26 365.14 225.18 387.86 222.45 387.86 228.53 365.14 231.26 365.14",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.65,
    y: 361.18,
    width: 3.37,
    height: 30.7,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.39,
    y: 365.14,
    width: 17.31,
    height: 46.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.39,
    y: 365.14,
    width: 15.72,
    height: 46.2,
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.82,
    y: 368.25,
    width: 3.44,
    height: 14.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.79,
    y: 355.71,
    width: 8.9,
    height: 55.63,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.79,
    y: 355.71,
    width: 8.9,
    height: 55.63,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.23,
    y: 355.71,
    width: 4.45,
    height: 55.63,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.64,
    y: 350.61,
    width: 165.04,
    height: 5.78,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.64,
    y: 350.61,
    width: 165.04,
    height: 5.78,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.6,
    y: 350.61,
    width: 62.09,
    height: 5.78,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.91,
    y: 295.55,
    width: 167.62,
    height: 5.78,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.91,
    y: 295.55,
    width: 167.62,
    height: 5.78,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.87,
    y: 295.55,
    width: 64.66,
    height: 5.78,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.49 409.92 82.11 409.92 80.09 411.34 264.51 411.34 262.49 409.92",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.67,
    y: 118.9,
    width: 124.51,
    height: 76.72,
    rx: 5.8,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.67,
    y: 118.9,
    width: 124.51,
    height: 76.72,
    rx: 5.8,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,260.84V192.18h-2v68.66a2.37,2.37,0,1,0,2,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,260.84V192.18h-2v68.66a2.37,2.37,0,1,0,2,0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Texts--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.36,152.22H177.84a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.19h43.52a1.19,1.19,0,0,1,1.19,1.19h0A1.18,1.18,0,0,1,221.36,152.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,162.52H177.84a1.18,1.18,0,0,1-1.18-1.19h0a1.18,1.18,0,0,1,1.18-1.18h43.52a1.18,1.18,0,0,1,1.19,1.18h0A1.19,1.19,0,0,1,221.36,162.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,172.82H177.84a1.18,1.18,0,0,1-1.18-1.19h0a1.19,1.19,0,0,1,1.18-1.19h43.52a1.19,1.19,0,0,1,1.19,1.19h0A1.19,1.19,0,0,1,221.36,172.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,183.11H177.84a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.19h43.52a1.19,1.19,0,0,1,1.19,1.19h0A1.18,1.18,0,0,1,221.36,183.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,130.71h2.77a3.41,3.41,0,1,1,0,6.8h-2.77Zm2.73,6.17a2.78,2.78,0,1,0,0-5.55h-2v5.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23,136.88v.63h-4.8v-6.8h4.65v.62h-3.94v2.42h3.52v.61h-3.52v2.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,130.71h.71v6.17h3.81v.63h-4.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,130.71h.72v6.8h-.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,130.71l-3,6.8h-.71l-3-6.8h.78l2.6,5.9,2.62-5.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.91,136.88v.63h-4.8v-6.8h4.66v.62h-3.94v2.42h3.51v.61h-3.51v2.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,137.51l-1.56-2.19a4.63,4.63,0,0,1-.54,0h-1.83v2.16h-.71v-6.8h2.54c1.73,0,2.77.88,2.77,2.33a2.11,2.11,0,0,1-1.55,2.14l1.66,2.33Zm0-4.47c0-1.09-.72-1.71-2.08-1.71h-1.81v3.41h1.81C158.48,134.74,159.2,134.11,159.2,133Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84,135.16v2.35h-.71v-2.35l-2.71-4.45h.76l2.33,3.82,2.33-3.82h.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.48,135.69h-3.79l-.81,1.82h-.75l3.1-6.8h.71l3.11,6.8h-.76Zm-.27-.58-1.63-3.65L171,135.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,130.71h2.77a3.41,3.41,0,1,1,0,6.8h-2.77Zm2.73,6.17a2.78,2.78,0,1,0,0-5.55h-2v5.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.18,130.71H188a3.41,3.41,0,1,1,0,6.8h-2.77Zm2.73,6.17a2.78,2.78,0,1,0,0-5.55h-2v5.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,137.51l-1.56-2.19a4.63,4.63,0,0,1-.54,0h-1.83v2.16h-.71v-6.8h2.54c1.73,0,2.77.88,2.77,2.33a2.11,2.11,0,0,1-1.55,2.14l1.66,2.33Zm0-4.47c0-1.09-.72-1.71-2.08-1.71h-1.81v3.41h1.81C197.08,134.74,197.8,134.11,197.8,133Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,136.88v.63h-4.8v-6.8h4.66v.62h-3.94v2.42h3.51v.61h-3.51v2.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,136.68l.28-.55a3.37,3.37,0,0,0,2.24.82c1.27,0,1.83-.53,1.83-1.2,0-1.86-4.19-.72-4.19-3.23,0-1,.78-1.87,2.51-1.87a3.79,3.79,0,0,1,2.1.61l-.24.57a3.47,3.47,0,0,0-1.86-.56c-1.24,0-1.8.55-1.8,1.23,0,1.86,4.19.74,4.19,3.21,0,1-.8,1.85-2.54,1.85A3.68,3.68,0,0,1,206.05,136.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,136.68l.28-.55a3.35,3.35,0,0,0,2.24.82c1.27,0,1.82-.53,1.82-1.2,0-1.86-4.18-.72-4.18-3.23,0-1,.78-1.87,2.5-1.87a3.82,3.82,0,0,1,2.11.61l-.24.57a3.48,3.48,0,0,0-1.87-.56c-1.24,0-1.79.55-1.79,1.23,0,1.86,4.18.74,4.18,3.21,0,1-.79,1.85-2.53,1.85A3.68,3.68,0,0,1,212,136.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,148.6v4.2h-.37l-2.7-3.4v3.4H118v-4.2h.37l2.7,3.41V148.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5,151.68h-2.34l-.5,1.12h-.46l1.92-4.2h.43l1.92,4.2H126Zm-.16-.36-1-2.25-1,2.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53,148.6v4.2h-.43v-3.36l-1.65,2.83h-.21l-1.64-2.81v3.34h-.43v-4.2h.37l1.82,3.12,1.8-3.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.87,152.42v.38h-3v-4.2h2.88V149h-2.44v1.49h2.17v.38h-2.17v1.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,162h-2.34l-.5,1.12h-.46l1.92-4.2h.43l1.92,4.2h-.46Zm-.16-.36-1-2.26-1,2.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,158.9H124a2.11,2.11,0,1,1,0,4.2h-1.71Zm1.69,3.81a1.72,1.72,0,1,0,0-3.43h-1.25v3.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.25,158.9H129a2.11,2.11,0,1,1,0,4.2h-1.71Zm1.68,3.81a1.72,1.72,0,1,0,0-3.43h-1.24v3.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,163.1l-1-1.35-.34,0h-1.12v1.33h-.45v-4.2h1.57c1.07,0,1.72.54,1.72,1.44a1.31,1.31,0,0,1-1,1.32l1,1.44Zm0-2.76c0-.67-.45-1.06-1.29-1.06h-1.11v2.11h1.11C134.6,161.39,135.05,161,135.05,160.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.51,162.71v.39h-3v-4.2h2.88v.38H137v1.5h2.18v.38H137v1.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.15,162.59l.18-.34a2.07,2.07,0,0,0,1.38.51c.79,0,1.13-.33,1.13-.75,0-1.15-2.58-.44-2.58-2,0-.62.47-1.16,1.54-1.16a2.29,2.29,0,0,1,1.3.38l-.15.35a2.2,2.2,0,0,0-1.15-.35c-.76,0-1.11.34-1.11.76,0,1.16,2.59.46,2.59,2,0,.62-.49,1.14-1.57,1.14A2.31,2.31,0,0,1,140.15,162.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,162.59l.18-.34a2.07,2.07,0,0,0,1.38.51c.79,0,1.13-.33,1.13-.75,0-1.15-2.58-.44-2.58-2,0-.62.48-1.16,1.54-1.16a2.29,2.29,0,0,1,1.3.38l-.15.35a2.2,2.2,0,0,0-1.15-.35c-.76,0-1.11.34-1.11.76,0,1.16,2.59.46,2.59,2,0,.62-.49,1.14-1.57,1.14A2.31,2.31,0,0,1,143.84,162.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,170.64c0,.89-.65,1.43-1.72,1.43h-1.13v1.33H118v-4.2h1.57C120.63,169.2,121.28,169.74,121.28,170.64Zm-.45,0c0-.67-.44-1.06-1.28-1.06h-1.12v2.1h1.12C120.39,171.68,120.83,171.3,120.83,170.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.93,171.3a2.2,2.2,0,1,1,2.2,2.13A2.11,2.11,0,0,1,121.93,171.3Zm4,0a1.77,1.77,0,1,0-1.76,1.74A1.7,1.7,0,0,0,125.89,171.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,172.89l.17-.35a2,2,0,0,0,1.39.51c.78,0,1.13-.33,1.13-.74,0-1.15-2.59-.44-2.59-2,0-.61.48-1.15,1.55-1.15a2.42,2.42,0,0,1,1.3.37l-.15.36a2.11,2.11,0,0,0-1.15-.35c-.77,0-1.11.34-1.11.76,0,1.15,2.58.46,2.58,2,0,.61-.49,1.14-1.56,1.14A2.29,2.29,0,0,1,126.93,172.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.78,169.58H130.3v-.38h3.4v.38h-1.48v3.82h-.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.83,172.27h-2.34l-.5,1.13h-.47l1.92-4.2h.44l1.92,4.2h-.47Zm-.16-.36-1-2.25-1,2.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,169.2h.44V173h2.35v.39H138.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.23,171.3a2.11,2.11,0,0,1,2.2-2.14,2.07,2.07,0,0,1,1.54.61l-.28.29a1.69,1.69,0,0,0-1.25-.5,1.74,1.74,0,1,0,0,3.48,1.66,1.66,0,0,0,1.25-.51l.28.28a2,2,0,0,1-1.54.62A2.11,2.11,0,0,1,143.23,171.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,171.3a2.2,2.2,0,1,1,2.2,2.13A2.11,2.11,0,0,1,147.46,171.3Zm4,0a1.77,1.77,0,1,0-1.76,1.74A1.7,1.7,0,0,0,151.42,171.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,169.2h1.71a2.11,2.11,0,1,1,0,4.2h-1.71Zm1.69,3.81a1.72,1.72,0,1,0,0-3.43h-1.24V173Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79,173v.39h-3v-4.2h2.88v.38h-2.44v1.49h2.17v.38h-2.17V173Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,180.93c0,.9-.65,1.44-1.72,1.44h-1.13v1.32H118v-4.2h1.57C120.63,179.49,121.28,180,121.28,180.93Zm-.45,0c0-.67-.44-1.05-1.28-1.05h-1.12V182h1.12C120.39,182,120.83,181.59,120.83,180.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,179.49v4.2h-.44v-1.94h-2.63v1.94h-.44v-4.2h.44v1.88h2.63v-1.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74,181.59a2.21,2.21,0,1,1,2.21,2.14A2.11,2.11,0,0,1,126.74,181.59Zm4,0a1.77,1.77,0,1,0-1.76,1.74A1.7,1.7,0,0,0,130.71,181.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,179.49v4.2h-.37l-2.7-3.4v3.4h-.44v-4.2h.37l2.7,3.41v-3.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,183.31v.38h-3v-4.2h2.88v.39h-2.44v1.49h2.17v.38h-2.17v1.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,150a.33.33,0,1,1,.65,0,.33.33,0,1,1-.65,0Zm0,2.55a.33.33,0,0,1,.65,0,.33.33,0,1,1-.65,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,160.24a.33.33,0,0,1,.65,0,.33.33,0,1,1-.65,0Zm0,2.56a.33.33,0,0,1,.65,0,.33.33,0,1,1-.65,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,170.54a.33.33,0,0,1,.65,0,.33.33,0,1,1-.65,0Zm0,2.56a.33.33,0,1,1,.65,0,.33.33,0,1,1-.65,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,180.84a.33.33,0,1,1,.65,0,.33.33,0,1,1-.65,0Zm0,2.55a.33.33,0,0,1,.65,0,.33.33,0,1,1-.65,0Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locator--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.37,110.63h0a12.66,12.66,0,0,0-17.91,17.9l8.95,9,9-9A12.66,12.66,0,0,0,239.37,110.63Zm-4.81,13.1h0a5.86,5.86,0,1,1,0-8.29h0A5.86,5.86,0,0,1,234.56,123.73Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,187.21c-4.69.44-11.37,22.92-11.37,22.92l12.9,1.67.65-21.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,187.21c-4.69.44-11.37,22.92-11.37,22.92l12.9,1.67.65-21.55Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.89,412.9H386a.66.66,0,0,1,.64.52l1.48,6.66a1.11,1.11,0,0,1-.85,1.31,1.07,1.07,0,0,1-.25,0c-2.94-.05-5.08-.23-8.78-.23-2.27,0-9.14.24-12.28.24s-3.56-3.11-2.27-3.4c5.77-1.25,10.11-3,12-4.65A1.78,1.78,0,0,1,376.89,412.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.32,412.66h9.09a.66.66,0,0,1,.64.52l1.48,6.66a1.11,1.11,0,0,1-.86,1.31,1,1,0,0,1-.24,0c-2.94-.05-5.09-.23-8.78-.23-2.28,0-9.14.24-12.29.24s-3.55-3.11-2.26-3.39c5.77-1.26,10.11-3,12-4.66A1.82,1.82,0,0,1,338.32,412.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.89,412.9H386a.66.66,0,0,1,.64.52l1.48,6.66a1.11,1.11,0,0,1-.85,1.31,1.07,1.07,0,0,1-.25,0c-2.94-.05-5.08-.23-8.78-.23-2.27,0-9.14.24-12.28.24s-3.56-3.11-2.27-3.4c5.77-1.25,10.11-3,12-4.65A1.78,1.78,0,0,1,376.89,412.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.32,412.66h9.09a.66.66,0,0,1,.64.52l1.48,6.66a1.11,1.11,0,0,1-.86,1.31,1,1,0,0,1-.24,0c-2.94-.05-5.09-.23-8.78-.23-2.28,0-9.14.24-12.29.24s-3.55-3.11-2.26-3.39c5.77-1.26,10.11-3,12-4.66A1.82,1.82,0,0,1,338.32,412.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.71,244.3H342c-3.78,20.63-15.6,104.41-7.12,169.47h13.46S347.06,315,358.94,283c1.36,17.09,15.25,130.66,15.25,130.66h13.7s-2.05-42.72-4.1-83.08C382.5,305.21,381.77,249.52,381.71,244.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.94,283a106.09,106.09,0,0,0-4.44,17.2c-1.11-15.21,3.33-31.34,3.33-31.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "341.64 244.78 381.64 244.78 381.64 249.54 341.13 249.05 341.64 244.78"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 367.35,
    y: 242.63,
    width: 1.43,
    height: 8.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.12,
    y: 242.63,
    width: 1.43,
    height: 8.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.47,
    y: 243.94,
    width: 7.4,
    height: 5.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,245.55h40.1c.91-19.51,6-46,7.38-53.13a1.92,1.92,0,0,0-1.47-2.27c-2-.44-4.09-.82-6.19-1.14a194.73,194.73,0,0,0-28.58-1.92c-4.23,0-6.89.12-6.89.12C341.15,204.6,341.25,232.64,341.66,245.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,245.55h40.1a327.27,327.27,0,0,1,4.09-34.84c1.35-8.32,2.67-15.16,3.29-18.29a1.46,1.46,0,0,0,0-.51,1.91,1.91,0,0,0-1.5-1.76c-2-.44-4.09-.82-6.19-1.14a194.73,194.73,0,0,0-28.58-1.92c-4.23,0-6.89.12-6.89.12C341.15,204.6,341.25,232.64,341.66,245.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.79,188.06c-3.44,3.12-11.86,2-11.86,2s-5.26-1.44-4.15-3.08c3.09-.51,4.59-2,5.21-3.81a8.93,8.93,0,0,0,.31-3.53,16.77,16.77,0,0,0-.26-2l10.41-7.71C373.09,175,371.42,184.37,374.79,188.06Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,174.82c-.41,6.25-5.55,8-8.06,8.32a8.93,8.93,0,0,0,.31-3.53Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,184.1l-9.95,4.48-.58-3.59-3.66,1.28a3,3,0,0,0-2,3.15l.41,4,5-2.76,2.51,3.55L377,188.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,184.1l-9.95,4.48-.58-3.59-3.66,1.28a3,3,0,0,0-2,3.15l.41,4,5-2.76,2.51,3.55L377,188.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,159.25c-1.95.76,13.38.91,13.38.91S358.6,155.91,350.05,159.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,159.25c-1.95.76,13.38.91,13.38.91S358.6,155.91,350.05,159.25Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,154.13s-3.4,9.87,1.37,14.39,7.21-14,7.21-14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.09,174.12c.1.35.22.69.35,1a10.14,10.14,0,0,0,5.12,5.43,9.32,9.32,0,0,0,6.71.53,9.15,9.15,0,0,0,4.11-2.65c3.51-3.82,3.26-8.06,3.41-15.27a9.87,9.87,0,0,0-14-9.34C354.88,157,354.3,167.7,356.09,174.12Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,165.61c.07.58-.26,1.07-.65,1.08s-.71-.45-.74-1,.28-1.07.66-1.08S364.91,165,364.93,165.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,165.86c.07.58-.27,1.07-.65,1.08s-.71-.45-.74-1,.28-1.07.66-1.08S358.28,165.3,358.3,165.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,166.07a21,21,0,0,1-2.61,5.12,3.43,3.43,0,0,0,2.84.42Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,163.12a.36.36,0,0,0,.36,0,2.79,2.79,0,0,1,2.46-.39.34.34,0,0,0,.45-.18.35.35,0,0,0-.18-.45h0a3.4,3.4,0,0,0-3.1.45.34.34,0,0,0-.11.47h0A.43.43,0,0,0,355.74,163.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,162.91a.42.42,0,0,0,.18-.08.34.34,0,0,0,0-.48h0a3.42,3.42,0,0,0-3.08-.66.33.33,0,0,0-.21.43h0a.35.35,0,0,0,.43.22h0a2.76,2.76,0,0,1,2.43.56A.35.35,0,0,0,366.15,162.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,154.39l-.42,3.18a2.37,2.37,0,0,1,1.16,3c-1.06,2.66.42,6.82,2.45,8.5,0,0,.08-1.16,1.05-.88s.65,6.31-1.29,9.17c0,0,2.91-2.57,4.6-8.89,1.56-5.83,1.8-10.71.62-13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,169a6.83,6.83,0,0,1-3.8,3.61c-2.25.85-3.59-1.11-3.15-3.35.42-2,2.07-4.88,4.42-4.75S380,166.92,379.16,169Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,174.53a.25.25,0,0,1-.24-.19.24.24,0,0,1,.18-.3,5.26,5.26,0,0,0,2.83-2.22.26.26,0,0,1,.35-.08.25.25,0,0,1,.08.34,5.6,5.6,0,0,1-3.14,2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,157.3s2.88-7.71,4.14-8.64,5.5-1.67,9.38-1.12,9.37,4.18,10.45,6,0,8.73,0,8.73l-8.56-2.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,157.3s2.88-7.71,4.14-8.64,5.5-1.67,9.38-1.12,9.37,4.18,10.45,6,0,8.73,0,8.73l-8.56-2.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,159.25s7.9-3.91,11.61-4,9,2.23,10.31,4.09c0,0-6.59,2-9.29.83A23.38,23.38,0,0,0,350.05,159.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.06 153.68 361.98 150.31 361.57 152.43 366.33 152.41 366.14 153.62 358.06 153.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.41 151.03 366.44 150.98 366.25 151.82 362.21 151.81 362.41 151.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.31,
    y: 204.93,
    width: 54.73,
    height: 38.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.31,
    y: 204.93,
    width: 54.73,
    height: 38.88,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.31,
    y: 204.93,
    width: 32.44,
    height: 38.88,
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.04,
    y: 204.93,
    width: 4.58,
    height: 4.08,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.04,
    y: 240.22,
    width: 4.58,
    height: 3.59,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.01,
    y: 235.39,
    width: 11.39,
    height: 6.32,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.04,
    y: 206.91,
    width: 8.42,
    height: 3.22,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.94,212s-1.56,8.91-3,10.4c-3.17,3.34-25.57,5.64-25.57,5.64l.35,5s23.45-1.44,27.89-4.64c3.67-2.64,7.94-15.54,7.94-15.54Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.35,229.54s-.74-2.51-1.39-3-9.84-.47-10.31-.47.28,7.52.93,8.27,8.17,0,9.38-.28S352,231.67,351.35,229.54Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,190.15c9.24,3.27-3.13,32.36-3.13,32.36L376.37,220S380.9,187.75,387.67,190.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.67,190.15c9.24,3.27-3.13,32.36-3.13,32.36L376.37,220S380.9,187.75,387.67,190.15Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.06 217.28 385.99 220.62 384.97 223.59 375.5 219.97 376.06 217.28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.63 203.43 370.83 200.42 370.24 202.49 374.99 202.89 374.69 204.08 366.63 203.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.2 201.18 375.22 201.47 374.96 202.3 370.93 201.93 371.2 201.18",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongressImage);
export default __webpack_public_path__ + "static/media/congressImage.279677e19a3e745b58b21d91ba0e9914.svg";
export { ForwardRef as ReactComponent };